import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Card, IconButton, Switch, Typography, useMediaQuery} from "@mui/material";
import {CheckBoxRounded} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {calcDiscountPrice, currencySymbol, getMediaURL, price, truncate} from "../../../../../config/values";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import {Link} from "react-router-dom";
import {isAdmin} from "../../../../../config/Permissions";
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Pencil , Trash} from 'lucide-react';
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import clsx from "clsx";
import {theme} from "../../../../../config/design/theme";



function ProductCard({item,reload,is_child, classes,dashboard,supplier_dashboard}){
    const { t } = useTranslation();
    const loginToken = localStorage.getItem('ACT');
    const [loading, setLoading] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const handleDelete = (item_id) =>{
        setLoading(true);
        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/products/delete`,data,config)
            .then(async response => {
                await reload();
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    const handleActive = (item_id) =>{

        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/products/toggle-active`,data,config)
            .then(response => {
                reload();
            })
            .catch(error => {
                console.error("Error fetching item data:", error);

            });
    }
    return (
            <Card className={clsx(classes.productCardPanel,!!dashboard && "dashboard-product",!!supplier_dashboard && "supplier-product")}>
                <div className="productCardMedia">
                    <CardMedia className="productCardImage"
                               component="img"
                               height={!!dashboard ? 60 : !isMobile ? 100 : 80  }
                               width={!!dashboard ? 60 : !isMobile ? 100 : 80 }
                               image={getMediaURL(item.thumbnail,'square')}
                               alt={item.name}
                    />
                </div>
                    <CardContent>
                        {
                            isAdmin() &&
                            <Box className="shopBg"
                                 component="section"
                                 display="flex"
                                 alignItems="center"
                            >
                                <Avatar className="avatarInProduct" src={getMediaURL(item.shop?.logo,'small')}/>
                                <Link className={classes.shopNameInCard} to={`/vendor/${item.shop?.slug}`}> {item.shop?.name}</Link>
                            </Box>
                        }


                        <div className="productInfo">
                            <Typography gutterBottom component={Link}  to={`/vendor/${item.shop?.slug}`} className="product-title-panel bold">
                                {
                                    !!dashboard ?
                                    truncate(item.name,12)
                                    :
                                    truncate(item.name,24)
                                }
                            </Typography>
                            <Typography gutterBottom  className={classes.priceInCard}>
                                {
                                    !!item.discount_percent ?
                                        <>
                                            <del style={{margin:"0 5px",color:'#333'}}>{price(item.price)}</del>
                                            <strong>{price(calcDiscountPrice(item.price, item.discount_percent))} {currencySymbol}</strong>
                                        </>
                                        :
                                        <strong>{price(item.price)} {currencySymbol}</strong>
                                }
                            </Typography>
                        </div>
                        {
                            !!dashboard &&
                                <Typography align="center">
                                    total sales: {item.total_sales}
                                </Typography>
                        }
                    </CardContent>
                {
                    !dashboard &&
                    <div className="action-holder">
                        <div className="cardOptions" >
                            <GetConfirmationButton
                                handleAction={() => handleDelete(item.id)}
                                question={t('doYouWanaDeleteItem')}
                                icon={<CheckBoxRounded/>}
                                tooltip={t('delete')}
                                size="small"
                                loading={loading}
                            >
                                <Trash className="lucide-icon-primary btn del-item"/>
                            </GetConfirmationButton>
                            <Switch
                                size="small"
                                checked={item.active}
                                onChange={() => handleActive(item.id)}
                                color="secondary"
                            />
                        </div>
                        <Button
                            variant="outlined"
                            className="editBtn"
                            color="secondary"
                            startIcon={<Pencil className="lucide-icon-secondary btn" />}
                            component={Link}
                            to={`/panel/${!!isAdmin() ? "manage" : "vendor"}/products/edit/${item.id}`}
                        >
                            {t('edit')}
                        </Button>
                    </div>
                }

            </Card>
    );
}
export default withStyles(Styles)(ProductCard);
